async function hasGitDirectory(root: FileSystemDirectoryHandle): Promise<boolean> {
  try {
    await root.getDirectoryHandle(".git", { create: false });
    return true;
  } catch {
    return false;
  }
}

/** True when the workspace root contains a `.git` directory. */
export async function isWorkspaceGitRepository(root: FileSystemDirectoryHandle | null): Promise<boolean> {
  if (!root) return false;
  return hasGitDirectory(root);
}
